import axios from "axios";
import qs from "qs";
import {NODE_URL_MAP} from "../../constants";

export interface IAddressKeyData {
    key: string;
    type: string;
    value: number|string|boolean;
}

export interface IStakedDataResult {
    staked: number;
}

export interface IDaoInfoResult {
    totalStaked: number;
    totalPower: number;
    addressPower: number;
    addressStakedNfts: string[];
}

export interface IVote {
    id: string;
    collectionId: string;
    owner: string;
    upPower: number;
    downPower: number;
    totalPower: number;
    voters: {[x:string]: {
        type: string;
        power: number;
        created: number;
        up: number;
        down: number;
    }};
    quorum: number;
    confirmed: boolean;
    rejected: boolean;
    createdAt: number;
}

export interface IResultById {
    voteId?: string;
    confirmed?: boolean;
    rejected?: boolean;
    createdAt?: number;
}

export interface IRewardInfo {
    votesIds?: string;
    costPerPower?: number;
    assetId?: string;
}

export const daoAddress = '3P975LUuqc7uBPiSxp3nemf2FZh62zfirSh';
export const daoBankAddress = '3PNDf51CQWHCRVMhLrbyid8zv8Uea6nVeAx';
export const puzzleStakeAddress = '3PFTbywqxtFfukX3HyT881g4iW5K4QL3FAS';

const createDappAddress = '3PFQjjDMiZKQZdu5JqTHD7HwgSXyp9Rw9By';

export const PuzzleDragonsSignArtIds = [
    '9iPLsYoz8fNyUp9qcgeAFPpMjKGcb4mNURhAZ7dfzXej',
    '2K847GdAcqaHHYn1dSS1F3NYriuquJKKzMoBES1cn4Mb',
    '7D1eCVeMbjHLpjYuqKZ96LoWPwD71quwuWpZxcuKnkJ7',
    'zjE5dwTv3AukQj6xMyddjcqA82bKvSNLeaKLhnFYKGf',
    '4T8QSrLLqUpHpi8SecSQT1p5tGo1CAskTGgYgUmXBYEb',
    'AjHkvxJpgxx8UAMmz6gvxjtBanGBHeEUaYxygdsTRcV6',
    '4jruFM1gvrtMHXiKdz2EKt12fHGjH5MT8YcZkF6KVGP7',
    'ZZ1cM8N3UC3uAdoCXJwTwkmpeTSFjpNB4GVa5UwYVGS',
    '6UAvojJpFxUjAoRFb3nhxCRUdGzFCvxCKniLtJqxVk77',
    '2NSvp5JX8YTNXWKXpE9kiZA22gg4DM2Yc7mcb9U6PkxB'
];

/**
 * Get staked data for DAO address
 * @returns 
 */
export const getStakedData = (): Promise<IStakedDataResult> => {
    const stakedKey = `${daoBankAddress}_staked`;
    const usdnClaimedKey = `${daoBankAddress}_DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p_claimed`;
    const keys = [
        stakedKey,
        usdnClaimedKey
    ]
    return axios.get<IAddressKeyData[]>(`${NODE_URL_MAP.W}/addresses/data/${puzzleStakeAddress}`, {
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: "repeat" })
        },
        params: {
            key: keys
        }
    }).then(({data}) => {
        const result = {
            staked: 0
        };
        data.forEach((item) => {
            if (item.key === stakedKey) {
                result.staked = item.value as number / 100000000;
            }
        });
        return result;
    });
}

/**
 * Get dao info
 * @returns 
 */
export const getDaoInfo = (address?: string): Promise<IDaoInfoResult> => {
    const totalStakedKey = 'total_staked';
    const totalPowerKey = 'total_power';
    const addressPowerKey = `address_${address}_power`;
    const addressStakedNftsKey = `address_${address}_stakedNfts`;

    const key = [
        totalStakedKey,
        totalPowerKey,
        addressPowerKey,
        addressStakedNftsKey
    ];

    return axios.get<IAddressKeyData[]>(`${NODE_URL_MAP.W}/addresses/data/${daoAddress}`, {
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: "repeat" })
        },
        params: {
            key
        }
    }).then(({data}) => {
        const result: IDaoInfoResult = {
            totalStaked: 0,
            totalPower: 0,
            addressPower: 0,
            addressStakedNfts: []
        };
        data.forEach((item) => {
            switch(item.key) {
                case totalStakedKey:
                    result.totalStaked = item.value as number;
                    break;
                case totalPowerKey:
                    result.totalPower = item.value as number;
                    break;
                case addressPowerKey:
                    result.addressPower = item.value as number;
                    break;
                case addressStakedNftsKey:
                    result.addressStakedNfts = item.value ? (item.value as string).split(',') : [];
                    break;
            }
        });

        return result;
    });
}

/**
 * Get dao NFT info
 * @returns 
 */
export const getDaoNFTInfo = (): Promise<IAddressKeyData[]> => {
    return axios.get<IAddressKeyData[]>(`${NODE_URL_MAP.W}/addresses/data/${daoAddress}`, {
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: "repeat" })
        },
        params: {
            matches: 'nft_(.*)',
        }
    }).then(({data}) => {
        const nftsData: IAddressKeyData[] = [];
        data.forEach((item) => {
            if (item.key.indexOf('nft_') === 0) {
                nftsData.push(item);
            }
        });

        return nftsData;
    });
}

/**
 * Get dao NFT info
 * @returns 
 */
export const getDaoVotes = (): Promise<{[x: string]: IVote}> => {
    return axios.get<IAddressKeyData[]>(`${NODE_URL_MAP.W}/addresses/data/${daoAddress}`, {
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: "repeat" })
        },
        params: {
            matches: '(vote|collection|voter)_(.*)',
        }
    }).then(({data}) => {
        const votes: any = {};
        data.forEach((item) => {
            if (item.key.indexOf('vote_') === 0) {
                const [, voteId, paramName] = item.key.split('_');
                if (!votes[voteId]) {
                    votes[voteId] = {
                        id: voteId,
                        voters: []
                    };
                }
                votes[voteId][paramName] = item.value;
            } else if (item.key.indexOf('voter_') === 0 && item.key.indexOf('_vote_') > 0 && item.key.indexOf('_assetId') > 0) {
                const [, address, , voteId,] = item.key.split('_');
                if (!votes[voteId]) {
                    votes[voteId] = {
                        id: voteId,
                        voters: {}
                    };
                }
                if (!votes[voteId].voters[address]) {
                    votes[voteId].voters[address] = {};
                }
                const [type, power] = (item.value as string).split(':');
                if (!votes[voteId].voters[address][type]) {
                    votes[voteId].voters[address][type] = 0;
                }
                votes[voteId].voters[address][type] += parseInt(power, 10);
            }
        });

        return votes;
    });
}

export const getVoteById = (collectionId: string): Promise<IResultById|null> => {
    const collectionIdKey = `collection_${collectionId}_voteId`;
    return axios.get<IAddressKeyData[]>(`${NODE_URL_MAP.W}/addresses/data/${daoAddress}`, {
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: "repeat" })
        },
        params: {
            key: [collectionIdKey],
        }
    }).then(({data}) => {
        let voteId = data?.[0]?.value as string;
        if (!voteId) return null;
        return axios.get<IAddressKeyData[]>(`${NODE_URL_MAP.W}/addresses/data/${daoAddress}`, {
            paramsSerializer: params => {
                return qs.stringify(params, { arrayFormat: "repeat" })
            },
            params: {
                key: [
                    `vote_${voteId}_confirmed`,
                    `vote_${voteId}_rejected`,
                    `vote_${voteId}_createdAt`
                ]
            }
        }).then(({data}) => {
            const result: IResultById = {voteId};
            data.forEach((item) => {
                const [, , key] = item.key.split('_');
                result[key as keyof IResultById] = item.value as any;
            });

            return result;
        });
    });
}

export const getAllNFTPower = async (selection?: string[]): Promise<number> => {
    const createDataResponse = await axios.get<IAddressKeyData[]>(`${NODE_URL_MAP.W}/addresses/data/${createDappAddress}`, {
        params: {
            matches: `collection_${daoAddress}_Market DAO Dragons_assetId_(.*)`,
        }
    });

    let paramKeys: string[] = [];

    const chunkLimit: number = 30;
    const chunks: string[][] = [];

    (createDataResponse?.data || []).forEach((item) => {
        if (selection?.length) {
            if (selection.indexOf(item.value as string) >= 0) {
                paramKeys.push(`nft_${item.value}_params`);
            }
        } else {
            paramKeys.push(`nft_${item.value}_params`);
        }
        if (paramKeys.length === chunkLimit) {
            chunks.push(paramKeys);
            paramKeys = [];
        }
    });

    if (paramKeys.length) {
        chunks.push(paramKeys);
    }

    let powerSum = 0;
    if (!chunks.length) {
        return 0;
    }
    for(let i = 0; i < chunks.length; i++) {
        const createDataResponse = await axios.get<IAddressKeyData[]>(`${NODE_URL_MAP.W}/addresses/data/${createDappAddress}`, {
            paramsSerializer: params => {
                return qs.stringify(params, { arrayFormat: "repeat" })
            },
            params: {
                key: chunks[i]
            }
        });
        let power = 0;
        (createDataResponse.data || []).forEach((item) => {
            if (item.value === 'gold') {
                power += 100;
            } else if (['green', 'red', 'purple'].indexOf(item.value as string) >= 0) {
                power +=40;
            }
        });
        powerSum += power;
    }

    return powerSum;
}

export const getRewards = (userAddress: string): Promise<{
    assetId: string;
    amount: number;
    claimed: boolean;
}[]> => {
    if (!userAddress) return Promise.resolve([]);
    return axios.get<IAddressKeyData[]>(`${NODE_URL_MAP.W}/addresses/data/${daoAddress}`, {
        params: {
            matches: `(reward|voter_${userAddress}_vote_)(.*)`,
        }
    }).then(({data}) => {
        const rewardsData: {
            [x: string]: IRewardInfo
        } = {};
        const addressVoteSpentPower: {
            [x: string]: number
        } = {};
        const claimedRounds: string[] = [];

        data.forEach((item) => {
            if (item.key.indexOf('reward_') >= 0) {
                const [, round, param] = item.key.split('_');
                if (!rewardsData[round]) {
                    rewardsData[round] = {};
                }
                rewardsData[round][param as keyof IRewardInfo] = item.value as any;
            }
            if (item.key.indexOf('voter_') >= 0) {
                const [, address, , voteId, param] = item.key.split('_');
                if (address === userAddress && param === 'spentPower') {
                    addressVoteSpentPower[voteId] = item.value as number;
                }
            }
            if (item.key.indexOf('rewardRound_') >= 0) {
                const [, round, , address, , , param] = item.key.split('_');
                if (address === userAddress && param === 'claimed') {
                    claimedRounds.push(round as string);
                }
            }
        });

        const result: {
            assetId: string;
            amount: number;
            claimed: boolean;
        }[] = [];

        Object.keys(rewardsData).forEach(round => {
            const spentPower = rewardsData[round].votesIds?.split(',').reduce((prev, curr) => {
                return (addressVoteSpentPower[curr] || 0) + prev;
            }, 0) || 0;
            if (round && spentPower > 0 && (rewardsData[round].costPerPower || 0) > 0) {
                result.push({
                    assetId: rewardsData[round].assetId as string,
                    amount: spentPower * (rewardsData[round].costPerPower || 0),
                    claimed: claimedRounds.includes(round)
                });
            }
        })

        return result;
    });
}

export const getAddressCollections = (address: string): Promise<string[]> => {
    if (!address.length) return Promise.resolve([]);

    return axios.get<IAddressKeyData[]>(`${NODE_URL_MAP.W}/addresses/data/${createDappAddress}`, {
        params: {
            matches: `nft_(.*)_data`,
        }
    }).then(({data}) => {
        const collectionNames = new Set<string>();

        data.forEach((item) => {
            if (item.value) {
                const data = JSON.parse((item.value as string).replaceAll('\'', '"'));
                if (data?.collection && data?.collection.indexOf(address + '_') >= 0) {
                    collectionNames.add(data.collection);
                }
            }
        });

        return Array.from(collectionNames);
    });
}